import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import it from "@/i18n/locales/it.json";
import en from "@/i18n/locales/en.json";

function initialLang() {
  if (typeof window === "undefined") return "it";
  const p = window.location.pathname;
  if (p === "/en" || p.startsWith("/en/")) return "en";
  const stored = localStorage.getItem("lattice_lang");
  if (stored === "en" || stored === "it") return stored;
  return "it";
}

i18n.use(initReactI18next).init({
  resources: { it: { translation: it }, en: { translation: en } },
  lng: initialLang(),
  fallbackLng: "it",
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

export default i18n;
